'use strict';

import { AexpPznExpiryModal } from './templates/aexp-pzn-expiry-modal/aexp-pzn-expiry-modal.ux';
import { AexpAmazonRedirectModal } from './templates/aexp-amazon-redirect-modal/aexp-amazon-redirect-modal.ux';

export { AexpPznExpiryModal };
export { AexpAmazonRedirectModal };
